import Link from 'next/link'

import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableRowItem,
  TableShimmer,
} from 'app/KinerjaShared/components/Table'
import TableRowStates from 'app/KinerjaShared/components/TableRowStates'
import { formatDate, isValidDate } from 'utils/datetime'
import {
  PERIODIK_STATE_BADGE_VARIANTS,
  PERIODIK_STATE_LABELS,
} from 'app/KinerjaShared/constants/periodik'

import type { PeriodikItem } from 'types/kinerja'

type TablePeriodikProps = {
  items: Array<PeriodikItem>
  isLoading?: boolean
  showAutosendColumn?: boolean
  nextPageResolver: (month: number) => string
  onClickDetailCta?: (month: number) => void
}
export function TablePeriodik({
  items,
  isLoading,
  showAutosendColumn,
  nextPageResolver,
  onClickDetailCta,
}: TablePeriodikProps) {
  const isEmpty = items.length === 0

  return (
    <Table rounded withOuterBorder className="bg-white">
      <TableHeader>
        <TableHeaderItem>Periode</TableHeaderItem>
        <TableHeaderItem>Dibuka pada</TableHeaderItem>
        {showAutosendColumn && (
          <TableHeaderItem>Dikirim otomatis pada</TableHeaderItem>
        )}
        <TableHeaderItem>Status</TableHeaderItem>
        <TableHeaderItem>Aksi</TableHeaderItem>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableShimmer columns={4} rows={6} />
        ) : isEmpty ? (
          <TableRowStates colSpan={4} type="EMPTY">
            <Text color="subdued">Belum ada data penilaian periodik.</Text>
          </TableRowStates>
        ) : (
          <>
            {items.map((item, id) => {
              const isActive =
                item.state === 'COMPLETED' || item.state === 'IN_PROGRESS'

              const parsedEndingDate = isValidDate(item.endingDate)
                ? formatDate(item.endingDate)
                : null

              const parsedStartingDate = isValidDate(item.startingDate)
                ? formatDate(item.startingDate)
                : null

              return (
                <TableRow key={id} className="font-semibold">
                  <TableRowItem>
                    <Text
                      variant={isActive ? 'body-sm-bold' : 'body-sm'}
                      color={isActive ? 'default' : 'subdued'}
                      as="span"
                    >
                      {item.label}
                    </Text>
                  </TableRowItem>
                  <TableRowItem>
                    <Text
                      variant={isActive ? 'body-sm-bold' : 'body-sm'}
                      color={isActive ? 'default' : 'subdued'}
                      as="span"
                    >
                      {parsedStartingDate || '-'}
                    </Text>
                  </TableRowItem>
                  {showAutosendColumn && (
                    <TableRowItem>
                      <Text
                        variant={isActive ? 'body-sm-bold' : 'body-sm'}
                        color={isActive ? 'default' : 'subdued'}
                        as="span"
                      >
                        {parsedEndingDate || '-'}
                      </Text>
                    </TableRowItem>
                  )}
                  <TableRowItem>
                    <Badge variant={PERIODIK_STATE_BADGE_VARIANTS[item.state]}>
                      {PERIODIK_STATE_LABELS[item.state]}
                    </Badge>
                  </TableRowItem>
                  <TableRowItem>
                    <div className="flex space-x-2 items-center">
                      <Link href={nextPageResolver(item.month)} passHref>
                        <Button
                          as="a"
                          type={undefined}
                          size="sm"
                          color={item.state === 'COMPLETED' ? 'white' : 'black'}
                          disabled={!isActive}
                          onClick={() => onClickDetailCta?.(item.month)}
                        >
                          {item.state === 'COMPLETED'
                            ? 'Cek'
                            : 'Lakukan Penilaian'}
                        </Button>
                      </Link>
                    </div>
                  </TableRowItem>
                </TableRow>
              )
            })}
          </>
        )}
      </TableBody>
    </Table>
  )
}
